import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import ResultsTable from "../components/ResultsTable";
import Highlights from "../components/Highlights";
import FAQ from "../components/FAQ";
import ChartArchive from "../components/ChartArchive";
import { todayLabel, todayISO } from "../mock";
import { fetchResults } from "../lib/api";
import { Info, BookOpen } from "lucide-react";

// Sort time strings like "10:05 AM", "1:35 PM" in reverse chronological order (latest first)
function sortByTime(arr) {
  return [...arr].sort((a, b) => {
    const toMinutes = (t) => {
      const match = t.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!match) return 0;
      let [, hour, min, period] = match;
      hour = parseInt(hour, 10);
      min = parseInt(min, 10);
      if (period.toUpperCase() === "PM" && hour !== 12) hour += 12;
      if (period.toUpperCase() === "AM" && hour === 12) hour = 0;
      return hour * 60 + min;
    };
    return toMinutes(b.time) - toMinutes(a.time);
  });
}

export default function HomePage() {
  const [madhur, setMadhur] = useState([]);
  const [starline, setStarline] = useState([]);

  useEffect(() => {
    const date = todayISO();
    fetchResults("madhur", { date })
      .then((rows) => setMadhur(sortByTime(rows)))
      .catch(() => {});
    fetchResults("starline", { date })
      .then((rows) => setStarline(sortByTime(rows)))
      .catch(() => {});
  }, []);

  return (
    <>
      <Hero />

      <section className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-6">
          <ResultsTable
            title="Today's Madhur Result"
            subtitle="Time-by-time numbers as declared"
            date={todayLabel()}
            rows={madhur}
            accent="amber"
          />
          <ResultsTable
            title="Today's Starline Result"
            subtitle="Live Starline draw record"
            date={todayLabel()}
            rows={starline}
            accent="amber"
          />
        </div>
      </section>

      <Highlights />

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="inline-flex items-center gap-2 text-amber-300">
              <BookOpen className="w-5 h-5" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em]">How To</span>
            </div>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-100">
              How to Check Madhur Lottery Result
            </h2>
            <p className="mt-3 text-slate-400 leading-relaxed">
              Result check karna ab bahut aasan hai. Jaise hi result ka time hota hai, hamara system automatic
              is page par latest numbers update kar deta hai.
            </p>
          </div>
          <ol className="space-y-4">
            {[
              "Daily result time par homepage open karein.",
              "Upar 'Latest Result' cards me current numbers check karein.",
              "Purane records ke liye Madhur Chart archive open karein.",
              "Starline ke liye dedicated chart page use karein.",
            ].map((s, i) => (
              <li key={i} className="flex items-start gap-4 p-4 rounded-xl bg-[#11172a] border border-white/5">
                <div className="shrink-0 w-9 h-9 rounded-lg bg-amber-400/15 border border-amber-400/30 text-amber-300 font-bold flex items-center justify-center font-mono">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <p className="text-slate-300 leading-relaxed text-sm md:text-base pt-1">{s}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <ChartArchive />
      <FAQ />

      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl border border-amber-400/15 bg-gradient-to-br from-amber-950/30 to-rose-950/20 p-6 md:p-8 flex items-start gap-4">
            <div className="shrink-0 w-10 h-10 rounded-lg bg-amber-400/15 border border-amber-400/30 flex items-center justify-center">
              <Info className="w-5 h-5 text-amber-300" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-slate-100">Informational Platform</h3>
              <p className="mt-1.5 text-sm text-slate-300 leading-relaxed">
                Yahan dikhaya gaya data users ko latest updates aur records check karne ke liye provide kiya
                jata hai. Yeh website betting ya gambling ko promote nahi karti. Kripya apne vivek aur
                niyam-kanoon ke anusar is information ka use karein.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
